var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#12A482"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0355 10.7584C30.8969 11.4364 31.0295 12.6643 30.3316 13.5011L17.321 29.101C16.9609 29.5327 16.4284 29.7948 15.8571 29.8213C15.2858 29.8478 14.7299 29.6363 14.3292 29.2399L8.60451 23.5777C7.82768 22.8093 7.83913 21.5747 8.63008 20.8201C9.42103 20.0654 10.692 20.0766 11.4688 20.8449L15.6175 24.9483L27.2122 11.046C27.9101 10.2092 29.1741 10.0805 30.0355 10.7584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWhite);
export default __webpack_public_path__ + "static/media/check-circle-white.50b6d303e4db142b61e148b30a195d8c.svg";
export { ForwardRef as ReactComponent };